import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

// const owners = () => import( /* webpackChunkName: "owners" */ './views/owners.vue');
// const realestate = () => import( /* webpackChunkName: "realestate" */ './views/realestate.vue');
// const purchase = () => import( /* webpackChunkName: "purchase" */ './views/purchase.vue');


const news = () => import( /* webpackChunkName: "news" */ './views/news.vue');
const newsCard = () => import( /* webpackChunkName: "news" */ '@/components/news/news-card.vue');
const contacts = () => import( /* webpackChunkName: "contacts" */ './views/contacts.vue');
const contactsQuality = () => import( /* webpackChunkName: "contacts" */ '@/components/contacts/contacts-quality.vue');
const flats = () => import( /* webpackChunkName: "flats" */ '@/components/flats/flats.vue');
const flatsCRM = () => import( /* webpackChunkName: "flats-crm" */ '@/components/flats-crm/flats-crm-page.vue');
const flatsCRMcard = () => import( /* webpackChunkName: "flats-crm-card" */ '@/components/flats-crm/flats-crm-card.vue');
const favoriteFlats = () => import( /* webpackChunkName: "flats-crm-favorite" */ '@/components/flats-crm/flats-crm-favorite.vue');

const home = () => import( /* webpackChunkName: "home" */ './views/home.vue');
const actions = () => import( /* webpackChunkName: "actions" */ './views/actions.vue');
const actionCard = () => import( /* webpackChunkName: "actions" */ '@/components/actions/action-card.vue');
const sales = () => import( /* webpackChunkName: "sales" */ './views/sales.vue');

const salesApp = () => import( /* webpackChunkName: "sales" */ '@/components/sales/sales-app.vue');
// const salesCardFlats = () => import( /* webpackChunkName: "sales" */ '@/components/sale-card/sale-card-flats.vue');

const SalesMap = () => import( /* webpackChunkName: "sales" */ './views/sales-map.vue');
const bazisClub = () => import( /* webpackChunkName: "bazis-club" */ './views/bazis-club.vue');
const bazisClubCard = () => import( /* webpackChunkName: "bazis-club" */ '@/components/bazis-club/bazis-club-card.vue');
const howToBy = () => import( /* webpackChunkName: "how-to-by" */ './views/how-to-by.vue');
const hypothec = () => import( /* webpackChunkName: "hypothec" */ './views/hypothec.vue');
const purchase = () => import( /* webpackChunkName: "purchase" */ './views/purchase.vue');
const hypothecCalculator = () => import( /* webpackChunkName: "hypothec-calculator" */ './views/hypothec-calculator-page.vue');
const bazisFinance = () => import( /* webpackChunkName: "bazis-finance" */ './views/bazis-finance.vue');
const favorite = () => import( /* webpackChunkName: "favorite" */ './views/favorite.vue');
const favoriteProjects = () => import( /* webpackChunkName: "favorite" */ '@/components/favorite/favorite-projects.vue');
const NotFound = () => import( /* webpackChunkName: "notFound" */ './views/404.vue');
const error = () => import( /* webpackChunkName: "error" */ './views/error.vue');
const howToTake = () => import( /* webpackChunkName: "how-to-take" */ './views/how-to-take.vue');
const video = () => import( /* webpackChunkName: "video" */ './views/video.vue');
const video_safety = () => import( /* webpackChunkName: "video" */ './views/video-safety.vue');
const online = () => import( /* webpackChunkName: "online" */ './views/online.vue');
const ENPF = () => import( /* webpackChunkName: "enpf" */ './views/enpf.vue');
// test pages
// const test_api_crm = () => import( /* webpackChunkName: "test_api_crm" */ './views/test_api_crm.vue');

Vue.use(Router)


const router = new Router({
	mode: 'history',
	hash: false,
	scrollBehavior (to, from, savedPosition) {
		// console.log(to);
		if (savedPosition) 
			return savedPosition
		else
			return {x: 0, y: 0}
		// // if (to.meta.parent != 'sale-card') {
		// return new Promise((resolve, reject) => {
		// 	// setTimeout(() => {
		// 		resolve({ x: 0, y: 0 })
		// 	// }, 500)
		// })
		// // }
	},
	routes: [
		{
			path: '/',
			name: 'home',
			// component: 'home',
			component: home,
			// component: () => import(/* webpackChunkName: "sales" */ './views/home.vue'),
			meta: { 
				crumbs: '/Главная',
				path: '/'
			}
		},
		// {
		// 	path: '/flats',
		// 	name: 'flats',
		// 	component: flats,
		// 	meta: { 
		// 		crumbs: '/Квартиры',
		// 		path: '/flats'
		// 	}
		// },

		{
			path: '/flats',
			name: 'flats-crm',
			component: flatsCRM,
			meta: { 
				crumbs: '/Квартиры',
				path: '/flats-crm'
			}
		},
		{
			path: '/flats/:id',
			name: 'flat-crm-card',
			component: flatsCRMcard,
			meta: { 
				crumbs: '/Квартиры',
				path: '/flats'
			}
		},
		{
			path: '/news',
			name: 'news--page',
			component: news,
			meta: { 
				crumbs: '/Новости',
				path: '/news'
			}
		},
		{
			path: '/news/:id',
			name: 'news-card',
			component: newsCard,
			meta: { 
				crumbs: '/Новости',
				path: '/news'
			}
		},
		{
			path: '/actions',
			name: 'actions--page',
			component: actions,
			meta: { 
				crumbs: '/Акции',
				path: '/actions'
			},
		},
		{ 
			path: '/actions/:id', 
			name: 'action-card', 
			component: actionCard,
			meta: { 
				crumbs: '/Акции/',
				path: '/actions/'
			},
		},
		{
			path: '/contacts',
			name: 'contacts--page',
			// component: contacts,
			redirect: {name: 'contacts-sales'},
			meta: { 
				crumbs: '/Контакты',
				path: '/contacts'
			}
		},
		{
			path: '/contacts/sales-offices',
			name: 'contacts-sales',
			component: contacts,
			meta: { 
				crumbs: '/Контакты/Офисы продаж',
				path: '/contacts/sales-offices'
			}
		},
		{
			path: '/contacts/quality',
			name: 'contacts-quality',
			component: contactsQuality,
			meta: { 
				crumbs: '/Контакты/Отдел гарантии и качества',
				path: '/contacts/quality'
			}
		},
		{
			path: '/owners',
			name: 'owners--page',
			// component: owners,
			meta: { 
				crumbs: '/Собственникам',
				path: '/owners'
			}
		},
		{
			path: '/realestate',
			name: 'realestate--page',
			redirect: {name: 'sales'},
			// component: realestate,
			meta: { 
				crumbs: '/Недвижимость',
				path: '/realestate'
			}
		},
		{ 
			path: '/sales', 
			name: 'sales', 
			component: sales,
			meta: { 
				crumbs: '/В продаже/Жилые комплексы',
				path: '/realestate/sales'
			},
		},
		{ // Внутренний лендинг проекта
			path: '/sales/:id', 
			name: 'sales-app', 
			component: salesApp,
			meta: { 
				crumbs: '/В продаже/Жилые комплексы/:id',
				path: '/',
				// parent: 'sale-card',
				// template: 'sale-card',
			},
		},
		{ 
			path: '/sales-map', 
			name: 'sales-map', 
			component: SalesMap,
			meta: { 
				crumbs: '/В продаже/Комплексы на карте',
				path: '/realestate/sales-map',
			}
		},
		{ 
			path: '/realestate/flats', 
			name: 'flats', 
			component: flats,
			meta: { 
				crumbs: '/В продаже/Подбор квартир',
				path: '/realestate'
			}
		},
		{
			path: '/purchase',
			name: 'purchase--page',
			// component: purchase,
			redirect: {name: 'how-to-by'},
			meta: { 
				crumbs: '/Приобритение',
				path: '/purchase'
			}
		},
		{
			path: '/bazis-club',
			name: 'bazis-club',
			component: bazisClub,
			meta: { 
				crumbs: '/Bazis Club',
				path: '/bazis-club'
			}
		},
		{ 
			path: '/bazis-club/:id', 
			name: 'bazis-club-card', 
			component: bazisClubCard,
			meta: { 
				crumbs: '/Bazis Club/:id',
				path: '/bazis-club/'
			},
		},
		{
			path: '/purchase/how-to-by',
			name: 'how-to-by',
			component: howToBy,
			meta: { 
				crumbs: '/Приобретение/Как купить?',
				path: '/purchase/how-to-by'
			}
		},
		{
			path: '/purchase/bazis-finance',
			name: 'bazis-finance',
			component: bazisFinance,
			meta: { 
				crumbs: '/Приобретение/Bazis Finance',
				path: '/purchase/bazis-finance'
			}
		},
		// {
		// 	path: '/purchase/new-owners',
		// 	name: 'how-to-take',
		// 	component: howToTake,
		// 	meta: { 
		// 		crumbs: '/Приобретение/Для новых собственников',
		// 		path: '/purchase/new-owners'
		// 	}
		// },
		{
			path: '/purchase/hypothec',
			name: 'hypothec',
			component: hypothec,
			meta: { 
				crumbs: '/Приобретение/Ипотека',
				path: '/purchase/hypothec'
			}
		},
		{
			path: '/purchase/hypothec-calculator',
			name: 'hypothec-calculator',
			component: hypothecCalculator,
			meta: { 
				crumbs: '/Приобретение/Калькулятор ипотеки',
				path: '/purchase/hypothec-calculator'
			}
		},
		{
			path: '/favorite',
			name: 'favorite-page',
			redirect: {name: 'favorite-projects'},
			component: favorite,
			meta: { 
				crumbs: '/Избранное',
				path: '/favorite'
			},
			children: [
				{ 
					path: '/favorite/favorite-projects', 
					name: 'favorite-projects',
					component: favoriteProjects,
					meta: {
						crumbs: '/Избранное/Жилые комплексы',
						path: '/favorite-projects'
					}
				},
				{ 
					path: '/favorite/favorite-flats', 
					name: 'favorite-flats',
					component: favoriteFlats,
					meta: {
						crumbs: '/Избранное/Квартиры',
						path: '/favorite/favorite-flats'
					}
				},
			]
		},
		{
			path: '/video',
			name: 'video-page',
			component: video,
			meta: { 
				crumbs: '/Видео',
				path: '/Video'
			}
		},
		{
			path: '/video-safety',
			name: 'video-page-safety',
			component: video_safety,
			meta: { 
				crumbs: '/Сейсмобезопасность зданий',
				path: '/video-safety'
			}
		},
		{
			path: '/purchase/online',
			name: 'online-page',
			component: online,
			meta: { 
				crumbs: '/Приобретение/Онлайн бронирование',
				path: '/purchase/online'
			}
		},
		{
			path: '/purchase/enpf',
			name: 'enpf-page',
			component: ENPF,
			meta: { 
				crumbs: '/Приобретение/Использование пенсионных накоплений',
				path: '/purchase/enpf'
			}
		},
		{ 
            path: '/404', 
            name: '404', 
            component: NotFound, 
        }, 
        { 
            path: '*', 
            redirect: '/404'
		},
		{ 
            path: '/error', 
            name: 'error', 
            component: error, 
		},
		{
			path: '/fine-finish',
			beforeEnter() {window.open('http://fine-finish.kz', '_blank',)}
			
		}
	]
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
	// console.log(to.name)
	store.commit('setPageName', to.name);
	// Счетчик избранных карточек из LocalStorage
	var items = localStorage.getItem('favorite_projects');
	items = items ? items.split(',') : [];
	store.commit('setFavoriteCount', items.length);
	// Закрываем мобильное меню
	store.commit('Open_Sendwich', false);
	document.getElementsByTagName('body')[0].classList.remove('overlay-open');
	// Конец счетчика изюранных карточек
	// if (to.meta.template != 'sale-card') {
	// 	store.commit('resetSaleCardContent', null);
	// }
  }
  if (to.name == 'bazis-club') {
	store.commit('set_view_bazis_Club_form', true);
  } else {
	store.commit('set_view_bazis_Club_form', false);
  }
  if (to.name != 'sales-app') {
	store.commit('clearSalesLandCardContent');
  }
  next()
})

router.afterEach((to, from) => {
  setTimeout(()=>{
	store.commit('breadCrumbInt', to.name);
 },650);
})

export default router
